import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import Image from '../../../Image';
import styles from './Tile.module.css';
import Badge from '../../../Badge';
import Spinner from '../../../Spinner/Spinner';

const bindClasses = classNameBind.bind(styles);

const Tile = ({
  icon,
  src,
  name,
  id,
  disabled,
  onClick,
  checked,
  multi,
  dataId,
  fontSize,
  wide,
  badge,
  pending,
  wordBreakingStyle,
}) => {
  const largeFontClassname = fontSize === 'large' ? 'large-font' : '';

  if (pending) {
    return (
      <div
        className={bindClasses('tile', 'empty', { disabled, checked, pending, wide })}
        data-ppuc-id={`${dataId}.Tile`}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <label
      className={bindClasses('tile', { disabled, checked, wide })}
      data-ppuc-id={`${dataId}.Tile`}
      htmlFor={id}
    >
      {badge.text && (
      <div className={bindClasses('badge-ctn')}>
        <Badge color={badge.color} text={badge.text} size="small" />
      </div>
      )}
      <input
        type={multi ? 'checkbox' : 'radio'}
        id={id}
        checked={checked}
        data-ppuc-id={`${dataId}.Tile.input`}
        onChange={onClick}
        disabled={disabled}
      />
      <div className={bindClasses('icon-ctn')}>
        {icon && <Icon name={icon} size="extraLarge" color={checked ? 'blue' : 'default'} />}
        {src && <Image src={src} />}
      </div>
      <div
        className={bindClasses('label', largeFontClassname)}
        style={{ wordBreak: wordBreakingStyle }}
        data-ppuc-id={`${dataId}.Tile.name`}
      >
        {name}
      </div>
    </label>
  );
};

Tile.defaultProps = {
  src: null,
  icon: null,
  disabled: false,
  checked: false,
  fontSize: 'default',
  wordBreakingStyle: 'normal',
  wide: false,
  pending: false,
  badge: {
    color: 'blue',
    text: '',
  },
};

export default Tile;
